import { type FC, useState } from 'react'
import { NavLink } from 'react-router-dom'

const SCHEDULING_ADMIN_BANNER_DISMISSED_KEY = 'schedulingAdminBannerDismissed'

interface SchedulingAdminBannerProps {
  userId: string
}

export const SchedulingAdminBanner: FC<SchedulingAdminBannerProps> = ({ userId }) => {
  const dismissedKey = `${SCHEDULING_ADMIN_BANNER_DISMISSED_KEY}:${userId}`
  const [isVisible, setIsVisible] = useState(() => {
    try {
      return localStorage.getItem(dismissedKey) !== 'true'
    } catch {
      return true
    }
  })

  const dismiss = () => {
    setIsVisible(false)
    try {
      localStorage.setItem(dismissedKey, 'true')
    } catch {
      return
    }
  }

  return isVisible ? (
    <div className='d-flex align-items-start zocks-gap-1 zocks-p-1.25 rounded-3 border zocks-border-color-gray-300 zocks-bg-color-gray-100'>
      <div className='d-flex align-items-start flex-1 gap-2'>
        <span className='d-flex align-items-center flex-shrink-0 paragraph-small'>
          <i className='bi bi-info-circle fs-6 lh-1 zocks-text-gray-900' aria-hidden='true' />
        </span>
        <span className='paragraph-small zocks-text-gray-900'>
          These Scheduling settings apply across your account. Go to{' '}
          <NavLink to='/account/profile-settings/scheduling' className='zocks-text-primary text-decoration-underline'>
            Profile
          </NavLink>{' '}
          to manage your personal preferences.
        </span>
      </div>
      <button type='button' className='btn btn-link p-0 border-0 d-flex zocks-text-gray-900 flex-shrink-0' aria-label='Dismiss' onClick={dismiss}>
        <i className='bi bi-x fs-6 lh-1' aria-hidden='true' />
      </button>
    </div>
  ) : null
}
